var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('hr'),_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('h2',[_vm._v("I am a remote vue compoent")])])
}
var staticRenderFns = []

export { render, staticRenderFns }